export default __webpack_public_path__ + "static/media/smootie.cc854046.png";